<template>
  <div class="container">
    <van-nav-bar fixed title="确认付款"/>
    <div class="patient_box">
      <p class="patient_name">就诊人：{{ detailInfo.name }}</p>
      <p class="describe_title">病情描述</p>
      <div class="describe_content">
        <!-- 需求变更，字段替换,原型显示的逻辑宣布注销 -->
        <div style="margin:5px 0;">{{ detailInfo.diagnose || '-' }}</div>
        <!-- <UploadImgs class="upload-imgs-box" :fileStr="detailInfo.images" isPreview/> -->
      </div>
    </div>
    <div class="doctor_diagnosis">
      <p class="diagnosis_title">医生诊断</p>
      <div class="diagnosis_box">
        <p class="illness_title">病种诊断</p>
        <p class="illness_detail_text main_color">
          {{ detailInfo.diagnose || '-' }}
           <!-- 需求变更，注销 -->
          <!-- <template v-if="subDiseaseTypeList.length !== 0">
                    <span v-for="(item, index) in subDiseaseTypeList" :key="index"
                          :style="{ color: index == 0 ? '#0082ef' : '', marginRight: '5px' }">
                        {{ item }}
                    </span>
          </template>
          <template v-else>病种待确认</template> -->
        </p>
      </div>
      <!-- <div class="diagnosis_box">
        <p class="illness_title">主诉症状</p>
        <div class="illness_detail_text">
          <template v-if="detailInfo.askDiseaseList?.length !== 0">
                    <span v-for="(item, index) in detailInfo.askDiseaseList" :key="index"
                          :style="{ marginRight: '5px' }">
                        {{ item.name }}
                    </span>
          </template>
          <template v-else>症状待确认</template>
        </div>
      </div>
      <div class="diagnosis_box">
        <p class="illness_title">用药周期</p>
        <div class="illness_detail_text">
          {{
            prescriptionInfo.medicationPeriod == 5 ? `${prescriptionInfo.mpValue}天` : `${optionsName(medicationPeriod, prescriptionInfo.medicationPeriod, 'remark', 'key')}天` || '无'
          }}
        </div>
      </div> -->
      <div class="diagnosis_box">
        <p class="illness_title">诊断</p>
        <p class="illness_detail_text">{{ prescriptionInfo.diagnose || '无' }}</p>
      </div>
      <div class="diagnosis_box">
        <p class="illness_title">医嘱</p>
        <p class="illness_detail_text">{{ prescriptionInfo.advice || '无' }}</p>
      </div>
    </div>
    <div class="pay_order_info">
      <div class="pay_info_box">
        <p class="info_label">问诊编号</p>
        <div class="info_value">
          <p>{{ detailInfo.askNo }}</p>
          <p class="copy_btn" @click="copyToClipboard(detailInfo.askNo)">复制</p>
        </div>
      </div>
<!--      <div class="pay_info_box">-->
<!--        <p class="info_label">商品总额</p>-->
<!--        <p class="info_value">￥{{ prescriptionInfo.totalFee }}</p>-->
<!--      </div>-->
      <!-- 需求变更，支付金额直接取值payAmount,原型显示的逻辑宣布注销 -->
      <!-- <div class="pay_info_box" v-if="Number(payRouteInfo.couponPrice)">
        <p class="info_label">优惠金额</p>
        <p class="info_value">-￥{{ payRouteInfo.couponPrice }}</p>
      </div> -->
      <div class="actual_payment_box">实付金额：<span>￥{{ detailInfo.payAmount }}</span>
        <!-- <span
          class="red">￥{{ subtract(add(add(detailInfo.totalFee,detailInfo.shippingFee),detailInfo.platformFriedFee) , Number(payRouteInfo.couponPrice)) }}</span> -->
        </div>
    </div>
    <div class="pay_btn_box">
      <!-- <p class="amount_money">￥{{  subtract(add(add(detailInfo.totalFee,detailInfo.shippingFee),detailInfo.platformFriedFee) , Number(payRouteInfo.couponPrice))  }}</p> -->
      <p class="amount_money">￥{{ detailInfo.payAmount }}</p>
      <p class="confirm_payment_btn" @click="confirmPayment">确认付款</p>
    </div>
  </div>
</template>
<script>
import api from "@/utils/request";
import { sexFilter} from "@/filters";
import {copyToClipboard} from "@/utils/utils";
import {optionsName} from '@/utils/index.js'
import {getAskDetail, getAskPrescription, getMedicationPeriod} from "@/api";
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      submitable: true,
      detailInfo: {},
      payRouteInfo: {couponPrice: 0},
      prescriptionInfo: {},
      subDiseaseTypeList: [],
      medicationPeriod: []
    }
  },
  computed: {
    ...mapGetters({diseaseList: 'getDiseaseType'}),
  },
  watch:{
    diseaseList:{
      deep: true,
      handler() {
        this.getAskDetail()
      }
    }

  },
  methods: {
    sexFilter,
    optionsName,
    copyToClipboard,
    async getAskDetail() {
      const {data: detailInfo} = await getAskDetail({askNo: this.payRouteInfo.askNo})
      this.detailInfo = detailInfo
      const subDiseaseTypeList = [];
      [...new Set([String(detailInfo.diseaseType), ...(detailInfo.subDiseaseTypes || '').split(',')])].forEach(item => {
        this.diseaseList.forEach(Item => {
          if (item == Item.key) {
            subDiseaseTypeList.push(Item.value)
          }
        })
      })
      this.subDiseaseTypeList = subDiseaseTypeList
      console.log(this.subDiseaseTypeList,'this.subDiseaseTypeList');
    },
    async onGetPrescriptionInfo() {
      try {
        const {data: prescriptionInfo} = await getAskPrescription({askNo: this.payRouteInfo.askNo})
        this.prescriptionInfo = prescriptionInfo
      } catch (error) {
        this.prescriptionInfo = {}
      }
    },
    async onGeMedicationPeriod() {
      try {
        const {data} = await getMedicationPeriod()
        this.medicationPeriod = data.list;
      } catch (error) {
        this.medicationPeriod = [];
        console.log(error)
      }
    },
    async confirmPayment() {
      if (!this.submitable) return false;
      this.submitable = false;
      try {
        const {data = {}} = await api({
          method: "post",
          url: "/order-service/pay/unifiedOrderV2",
          data: {
            payType: 1,
            orderNo: this.detailInfo.orderNo,
            couponId: this.payRouteInfo.couponId,
            // 需求变更，字段2替换为4
            origin: 4,
			payForAnother: this.payRouteInfo.payForAnother || 0,
          },
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (data.freeOrder == "1") {
          this.$toast("支付成功");
          setTimeout(() => {
            this.submitable = true;
            this.$router.back();
          }, 1000);
        } else {
          window.location.href = data.paySkipUrl
        }
      } catch (error) {
      }
      this.submitable = true;
    },
    // 减法运算
    subtract(a, b) {
      return this.transferToNumber(this.add(a, -b)) || 0;
    },
    // 加法运算
    add(a, b) {
      const precision = Math.max(this.getPrecision(a), this.getPrecision(b));
      const multiplier = Math.pow(10, precision);
      const result = (Math.round(a * multiplier) + Math.round(b * multiplier)) / multiplier;
      return this.transferToNumber(result)
    },
    getPrecision(num) {
      const str = String(num);
      const decimalIndex = str.indexOf(".");
      return decimalIndex === -1 ? 0 : str.length - decimalIndex - 1;
    },
    // 处理出现科学计数法
    transferToNumber(num) {
      if (isNaN(num)) {
        return num
      }
      num = '' + num
      num = parseFloat(num)
      let eformat = num.toExponential() // 转换为标准的科学计数法形式（字符串）
      let tmpArray = eformat.match(/\d(?:\.(\d*))?e([+-]\d+)/) // 分离出小数值和指数值
      let number = num.toFixed(Math.max(0, (tmpArray[1] || '').length - tmpArray[2]))
      return number || 0
    },

  },
  created() {
    this.payRouteInfo = this.$route.query
    this.getAskDetail()
    this.onGetPrescriptionInfo()
    this.onGeMedicationPeriod()

  }
}
</script>


<style scoped lang="scss">
@import "@/assets/css/base";

$mainColor: #2f4593;
.red {
  color: red;
}

.main_color {
  color: $mainColor;
}

.container {
  //height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f4f4f4;
  font-size: 14px;
  padding-bottom: 70px;
  padding-top: 40px;
}

.patient_box {
  margin-top: 10px;
  padding: 12px;
  background: #fff;

  .patient_name {
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 8px;
    border-bottom: 1px solid rgba(170, 166, 166, 0.13);

  }

  .describe_title {
    font-size: 14px;
    padding-top: 8px;
  }

  .describe_content {
    font-size: 14px;
    word-break: break-all;
  }
}

.doctor_diagnosis {
  margin-top: 10px;
  padding: 12px;
  background: #fff;

  .diagnosis_title {
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1px solid rgba(170, 166, 166, 0.13);
    padding-bottom: 8px;

  }

  .diagnosis_box {
    margin-top: 10px;

    .illness_title {
      font-size: 18px;

    }

    .illness_detail_text {
      font-size: 14px;
      margin-top: 6px;

    }
  }

}

.pay_order_info {
  margin-top: 10px;
  padding: 12px;
  background: #fff;

  .pay_info_box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .info_label {
    }

    .info_value {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .copy_btn {
        margin-left: 4px;
      }
    }
  }

  .actual_payment_box {
    text-align: right;
  }

}

.pay_btn_box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-top: 10px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;

  .amount_money {
    font-size: 18px;
    font-weight: bold;
    color: red;
  }

  .confirm_payment_btn {
    background: $mainColor;
    text-align: center;
    border-radius: 30px;
    padding: 10px 12px;
    color: #FFFFFF;

  }
}
</style>